import { Award, Users, Clock, Shield } from "lucide-react"

const features = [
  {
    icon: Award,
    title: "Industry Expertise",
    description: "Years of experience delivering complex infrastructure projects",
  },
  {
    icon: Users,
    title: "Professional Team",
    description: "Certified technicians committed to excellence",
  },
  {
    icon: Clock,
    title: "On-Time Delivery",
    description: "We respect your timeline and deliver as promised",
  },
  {
    icon: Shield,
    title: "Quality Assured",
    description: "Rigorous quality control on every project",
  },
]

export function WhyUsSectionModern() {
  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 items-center">
          <div className="space-y-6">
            <div className="space-y-4">
              <h2 className="text-4xl font-bold tracking-tight">
                Why Choose <span className="text-primary">World Connections</span>
              </h2>
              <p className="text-lg text-muted-foreground">
                We're more than just a service provider — we're your trusted partner in building reliable infrastructure that stands the test of time.
              </p>
            </div>
            
            <div className="space-y-6 pt-6">
              {features.map((feature, index) => {
                const Icon = feature.icon
                return (
                  <div key={index} className="flex gap-4">
                    <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
                      <Icon className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold mb-1">{feature.title}</h3>
                      <p className="text-muted-foreground">{feature.description}</p>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
          
          <div className="relative h-[500px] rounded-3xl bg-gradient-to-br from-primary/20 to-primary/5 p-8">
            <div className="h-full rounded-2xl bg-background/50 backdrop-blur-sm border-2 border-primary/20 p-8 flex flex-col justify-center">
              <div className="space-y-8">
                <div className="space-y-2">
                  <div className="text-sm font-medium text-primary">Our Promise</div>
                  <div className="text-2xl font-bold">Reliable. Professional. Efficient.</div>
                </div>
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="h-2 flex-1 bg-primary/20 rounded-full overflow-hidden">
                      <div className="h-full w-[95%] bg-primary rounded-full" />
                    </div>
                    <span className="text-sm font-medium">95% Quality Score</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="h-2 flex-1 bg-primary/20 rounded-full overflow-hidden">
                      <div className="h-full w-[98%] bg-primary rounded-full" />
                    </div>
                    <span className="text-sm font-medium">98% On-Time</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="h-2 flex-1 bg-primary/20 rounded-full overflow-hidden">
                      <div className="h-full w-[100%] bg-primary rounded-full" />
                    </div>
                    <span className="text-sm font-medium">100% Satisfaction</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
